export default __webpack_public_path__ + "static/strongest-encryption-0080473741e3e92cd654d75168bc674b.png";